import { call, put, select } from 'typed-redux-saga'

import services from '@services'
import { ApplicationState } from '@store/types'
import { logout } from '@utils/functions'
import {
  deleteAnexoContracheque,
  setIsDoneContracheque,
  setIsErrorContracheque,
  setIsLoadingContracheque,
} from '@store/refinanciamento/contrachequeDocumentos/actions'
import { BridgeService } from '@services/bridge'
import { HttpStatus } from '@services/base'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ErroType } from '@utils/types'
import { PostEnviarDocumentosWebServiceType } from '@services/postEnviarDocumentosWebService'

import { Anexo } from '../types'
import { deleteAnexoFoto, setIsDoneFoto, setIsErrorFoto, setIsLoadingFoto } from '../actions'

interface Props {
  payload: {
    anexos: Anexo[]
    tipo: string
    callbackError?: () => void
  }
  type: string
}

export default function* sendToS3PDFSaga({ payload }: Props) {
  const { cpfSession } = yield* select((s: ApplicationState) => s.session)
  const { cpfDadosPessoais } = yield* select(
    (s: ApplicationState) => s.refinanciamento.dadosPessoais,
  )
  const tipoDocumentos = yield* select(
    (s: ApplicationState) => s.refinanciamento.proposta.tipoDocumento,
  )
  const { accessToken } = yield* select((state: ApplicationState) => state.session)
  const regex = /data:.*base64,/
  try {
    const files = payload.anexos.flatMap((e) => {
      const ext = e.anexo.nome.split('.').pop()
      return e.anexo.blobs.map((blob) => ({
        file: blob.data.replace(regex, ''),
        extension: e.anexo.nome.includes('.') && ext ? `.${ext}` : '',
      }))
    })
    const type =
      tipoDocumentos?.filter((tipo) => tipo.idTipoDocumento === payload.tipo)[0]?.idTipoDocumento ||
      payload.tipo

    const service = BridgeService.isBrowser()
      ? services.postEnviarDocumentosWebService
      : services.postEnviarDocumentosAppService

    yield* call(
      service as PostEnviarDocumentosWebServiceType,
      { files, type },
      cpfDadosPessoais ?? cpfSession ?? '',
      accessToken,
    )

    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'postEnviarDocumentosService' }))

    if (payload.tipo === 'RG_CNH') {
      yield put(setIsErrorFoto(false))
      yield put(setIsDoneFoto(true))
      yield put(setIsLoadingFoto(false))
    } else {
      yield put(setIsDoneContracheque(true))
      yield put(setIsLoadingContracheque(false))
    }
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'postEnviarDocumentosService' }))
    const erroTyped = error as ErroType
    if (BridgeService.isBrowser() && erroTyped.status === HttpStatus.UNAUTHORIZED) {
      yield put(
        showError({
          title: 'Sessão expirada',
          message: 'Efetue o login novamente.',
          actionTitle: 'Continuar',
          functionCallback: () => logout(),
        }),
      )
    }
    if (payload.tipo === 'RG_CNH') {
      yield put(setIsErrorFoto(true))
      yield put(setIsLoadingFoto(false))
      yield put(setIsDoneFoto(false))
      yield put(deleteAnexoFoto(0))
    } else {
      yield put(setIsErrorContracheque(true))
      yield put(setIsLoadingContracheque(false))
      yield put(setIsDoneContracheque(false))
      yield put(deleteAnexoContracheque(0))
    }

    if (payload.callbackError) {
      yield payload.callbackError()
    }
  }
}
